import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
    Handler,
} from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

interface Parameter {
    isMinError: boolean;
}

type HandlerType = CustomHandler<Parameter>;

export const CenQtyMin: HandlerType = props => {
    props.dispatch({
        type: "Pages/CenQtyMinState",
        isMinError: props.parameter.isMinError,
    });
};

export const chain = [CenQtyMin];

const cenQtyMin = createHandlerChainRunner(chain, "CenQtyMin");
export default cenQtyMin;
